// extracted by mini-css-extract-plugin
export default {"banner":"V0SxiU2It0bmzqZKpvQ4","fadeIn":"l_H12q7fxOmvEm7iSoxh"};